import { Component, EventEmitter, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ABCisTableModel } from 'src/app/components/abcis-table/abcis-table.component';

@Component({
  selector: 'app-master-product-list',
  standalone: false,
  templateUrl: './master-product-list.component.html',
  styleUrls: ['./master-product-list.component.scss'],
  encapsulation: ViewEncapsulation.None

})
export class MasterProductListComponent implements OnInit {
  @Output() onSelectRow = new EventEmitter<any>();
  @Output() onUnSelectRow = new EventEmitter<any>();

  public masterTableConfig: ABCisTableModel;
  public selectedMasterProduct: any;

  constructor(
    private router:Router,
    private activatedRoute:ActivatedRoute,
  ) { }

  ngOnInit() { }
}
